import { useState } from "react";
import { getEcrImageNames } from "../../../services/aws/ecr";
import { getMasterCompanyNames } from "../../../services/gsuite/sheets";
import { getPlatformData } from "../../../services/mongo/platforms";

const useScraperData = (scraperClass) => {
  const [companyNames, setCompanyNames] = useState([]);
  const [scraperVersionNames, setScraperVersionNames] = useState([]);
  const [platformOptionData, setPlatformOptionData] = useState([]);

  const fetchData = async () => {
    const [companyRes, scraperRes, platformRes] = await Promise.all([
      getMasterCompanyNames(scraperClass),
      getEcrImageNames(),
      getPlatformData(),
    ]);

    // Fetch company names
    const companyData = await companyRes.json();
    setCompanyNames(companyData.company_names.sort());

    // Fetch scraper versions
    const scraperData = await scraperRes.json();
    let formattedVersions = [];
    if (scraperClass === "Twitter") {
      formattedVersions = scraperData["twitter-images"].map(({ imageDigest: key, imageTag: val }) => ({
        key,
        val,
      }));
    } else {
      formattedVersions = scraperData["nigel-scraper-images"].map(({ imageDigest: key, imageTag: val }) => ({
        key,
        val,
      }));
    }
    setScraperVersionNames(formattedVersions);

    // Fetch platform names
    const platformData = await platformRes.json();
    setPlatformOptionData(platformData.platform_names);
  };

  return { companyNames, scraperVersionNames, platformOptionData, fetchData };
};
export default useScraperData;
